import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-group-class-state-has-join',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<lp2-live-class-state-view-title [labelKey]="stateTextKey"></lp2-live-class-state-view-title>`,
})
export class GroupClassStateHasJoinComponent {
  @Input() stateTextKey: string;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-has-join.component.ts